import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { valuationEffects, valuationSelectors } from 'features/valuation/slice';

import ValuationMethod from './ValuationMethod';
import AutocompleteSymbol from './ValuationMetric/AutocompleteSymbol';
import DropdownMetrics from './ValuationMetric/DropdownMetric';
import ValuationResult from './ValuationResult';
import {
  SLabelBody,
  SValuationBodyContainer,
  SValuationBodyForm,
  SValuationBodyResult,
  SValuationFormWrapper,
  SValuationResultWrapper,
} from './styled';

const ValuationBody = () => {
  const { getValuationMetrics } = valuationEffects;
  const { valuationResult, isMobileView } = useSelector(valuationSelectors);
  const {
    data: { symbol },
  } = valuationResult;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getValuationMetrics());
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <SValuationBodyContainer
      isResultAvailable={Boolean(symbol)}
      isMobileView={isMobileView}
    >
      <SValuationBodyForm isResultAvailable={Boolean(symbol)}>
        <SLabelBody>Method and Metric</SLabelBody>
        <SValuationFormWrapper>
          <form onSubmit={handleSubmit}>
            <ValuationMethod />
            <AutocompleteSymbol />
            <DropdownMetrics />
          </form>
        </SValuationFormWrapper>
      </SValuationBodyForm>
      {symbol && (
        <SValuationBodyResult>
          <SLabelBody>Result</SLabelBody>
          <SValuationResultWrapper>
            <ValuationResult />
          </SValuationResultWrapper>
        </SValuationBodyResult>
      )}
    </SValuationBodyContainer>
  );
};

export default ValuationBody;
